import classNames from 'classnames';
import React from 'react';
import { StudyModelSectionAccordionItemContent } from '../StudyModelSectionAccordionItemContent/StudyModelSectionAccordionItemContent';
import type { LegacyStudyModelViewModel } from '~/Pages/CampusStudyPage/ViewModel/StudyModel/LegacyStudyModelViewModel.csharp';
import { AccordionItem } from '~/Partials/AccordionComponent/AccordionItem';
import { ActivityIndicator } from '~/Partials/ActivityIndicator/ActivityIndicator';
import { useFetchData } from '~/Partials/FetchData/useFetchData';
import styles from './StudyModelSectionAccordionItemWithFetch.module.css';

export interface StudyModelSectionAccordionItemWithFetchProps {
    heading: string;
    contentAdditionalInfo: string;
    prerequisitesHeading: string;
    fetchUrl: string;
    translations: StudyModelSectionAccordionItemTranslations;
    className?: string;
}

export interface StudyModelSectionAccordionItemTranslations {
    genericErrorMessage: string;
}

export const StudyModelSectionAccordionItemWithFetch: React.FC<
    React.PropsWithChildren<StudyModelSectionAccordionItemWithFetchProps>
> = props => {
    const { heading, contentAdditionalInfo, prerequisitesHeading, fetchUrl, translations, className } = props;
    const { genericErrorMessage } = translations;

    const { loading, error, data } = useFetchData<LegacyStudyModelViewModel>({
        url: fetchUrl,
    });

    const renderStudyModelAccordionContent = () => {
        if (loading) {
            return <ActivityIndicator modal={false} />;
        }

        if (error) {
            return <span className={styles.Error}>{error}</span>;
        }

        if (data) {
            return (
                <StudyModelSectionAccordionItemContent
                    heading={contentAdditionalInfo}
                    data={data}
                    prerequisitesHeading={prerequisitesHeading}
                />
            );
        }

        return <span className={styles.Error}>{genericErrorMessage}</span>;
    };

    return (
        <div className={classNames(styles.AccordionItemWrapper, className)}>
            <AccordionItem
                className={styles.AccordionItem}
                variant="solid"
                color="white"
                contentSpacing="default"
                headerContent={heading}
            >
                <div className={styles.AccordionContent}>{renderStudyModelAccordionContent()}</div>
            </AccordionItem>
        </div>
    );
};
